// extracted by mini-css-extract-plugin
export var disabled = "_4g-3";
export var growableInput = "_4g-0";
export var tagContainer = "_4g-2";
export var textInput = "_4g-1";